"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOverviewInfoFlights = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ReservationOverviewInfoFlightsCard_1 = require("./ReservationOverviewInfoFlightsCard");
require("./index.scss");
const ReservationOverviewInfoFlights = (props) => {
    const { className, flights } = props;
    const classNames = (0, classnames_1.default)('reservation-overview-info-flights', className);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h4", { className: 'reservation-overview-info-flights__title' },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary/SubTitle:Flight', defaultMessage: 'Flight information' })),
        react_1.default.createElement("div", { className: 'reservation-overview-info-flights__list' }, flights.map(flight => (react_1.default.createElement(ReservationOverviewInfoFlightsCard_1.ReservationOverviewInfoFlightsCard, { className: 'reservation-overview-info-flights__card', key: flight.originAirportName, ...flight }))))));
};
exports.ReservationOverviewInfoFlights = ReservationOverviewInfoFlights;
//# sourceMappingURL=index.js.map